// Func = limiting Scope for this file
'use strict';
function successFunction(){
	window.location.href = "/thank-you-rfp";
}
(function(){

	function resizeWindow(){

	}

    $('.multiple-items').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true
              }
        }],
    });

    let getClassLoadSvg = document.getElementById('svg-load');
    let bodyOpen = document.querySelector('body');

    //-------- this function add a class to an element that you need animate
        const timeAnimations = (element, classElement, timeAnimation) => {
            setTimeout(function () {
                element.classList.add(classElement);
            }, timeAnimation);
        }
    //-------- this function add a class to an element that you need animate

    //-------- this function add a class to an element that you need animate
		const removeTimeAnimations = (element, classElement, timeAnimation) => {
			setTimeout(function () {
				element.classList.remove(classElement);
			}, timeAnimation);
		}
    //-------- this function remove a class of an element that you need remove some animation

    //-------- this function run the code inside it, when the site charge
    function loadSite() {
        timeAnimations(bodyOpen, 'body-open', 800);
        
    }

    window.onload = loadSite;
    //-------- this function run the code inside it, when the site charge

	$(document).ready(function () {

        $('.waterpark-lighbox').fancybox({
            tpl: {
                wrap     : '<div class="fancybox-wrap waterpark-fancybox" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
                image    : '<img class="fancybox-image" src="{href}" alt="" />',
                iframe   : '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0"' + ($.browser.msie ? ' allowtransparency="true"' : '') + '></iframe>',
                error    : '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
                closeBtn : '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
                next     : '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
                prev     : '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'
            }
        })



		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();


        $( "#footer #email-signup .signup-btn" ).insertAfter( "#email-signup .field:nth-child(4):not(.gdpr)" );

        $('[data-fancybox]').fancybox();


        if($('body#home').length > 0) {
            if(getClassLoadSvg){
                timeAnimations(getClassLoadSvg, 'load', 0);  
                timeAnimations(getClassLoadSvg, 'bounce', 1500);
            }

            let closeLoadPage = document.querySelector('.loading-page');
            if(closeLoadPage){
                timeAnimations(closeLoadPage, 'close-loading-page', 3500);
            }
            let initfirstTextHome = document.querySelector('.js-first-title');
            let initSecondTextHome = [...document.getElementsByClassName('js-second-title')];
            initSecondTextHome.forEach(function (eachLetter) {
                if([...closeLoadPage.classList.contains('close-loading-page')]){
                    timeAnimations(initfirstTextHome, 'init-first-text-home', 7000);
                    timeAnimations(eachLetter, 'init-second-text-home', 7700);
                }
            });
        }

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		const burgerMenu = [...document.getElementsByClassName('burger')];
		const mainMenuSite = document.getElementById('primary-nav');
        const mainMenuList = document.getElementById('privary-navigation');
        const logoSite = document.getElementsByClassName('logo')[0];

		burgerMenu.forEach(burgerIcon => {

            burgerIcon.addEventListener('click', function () {
            	let burgerElement = this;
            	let addClassBurger = burgerElement.classList.toggle('burger-open');
            	let changeTextBurgerMenu = burgerElement.querySelector('span');

				if(burgerElement.classList.contains('burger-open')){

					changeTextBurgerMenu.innerHTML = 'Close';

                    timeAnimations(mainMenuSite, 'open-menu', 10);
                    timeAnimations(logoSite, 'logo-hide', 300);
                    timeAnimations(logoSite, 'logo-open', 600);
                    timeAnimations(mainMenuList, 'open-menu-list', 500);
                    timeAnimations(mainMenuSite, 'primary-nav-menu', 600);
                    timeAnimations(burgerElement, 'burger-close', 700);
				}else{

                    changeTextBurgerMenu.innerHTML = 'Menu';

                    removeTimeAnimations(burgerElement, 'burger-close', 10);
                    removeTimeAnimations(mainMenuSite, 'primary-nav-menu', 100);
                    removeTimeAnimations(mainMenuList, 'open-menu-list', 300);
                    removeTimeAnimations(mainMenuSite, 'open-menu', 300);
                    removeTimeAnimations(logoSite, 'logo-open', 800);
                    removeTimeAnimations(logoSite, 'logo-hide', 100);
				}
			})
		});

        // const becomeMemberbtn = document.getElementsByClassName('js-become-member__close')[0];
        // const becomeMemberBox = document.getElementsByClassName('js-become-member')[0];

        // const headerBox = document.getElementById('header') || [];

        // becomeMemberbtn.addEventListener('click', function () {
        //     becomeMemberBox.classList.add('close-member-box');
        //     headerBox.classList.add('header-top');
        // });

        $('.waterpark-menu').insertBefore('body#waterpark #header .container .main-menu');
        $('.spa-menu').insertBefore('body#spa #header .container .main-menu');
        $('.spa-menu').insertBefore('body#landing-page-month-offer #header .container .main-menu');
        
        //change text slick buttons tidal cove

        const changeTextSlickDots = (dotButton, newTextDot) => {

            let getTextDot = document.querySelector(dotButton) || [];
            getTextDot.textContent = newTextDot;

            // return getTextDot;
        };

        /*$('.slider-module__box-txt .sym-slides').slick({
            customPaging : function(slider, i) {
                var title = $(slider.$slides[i].data('title'));
                return '<a>' + title + '</a>';
            },
        })*/
    

        // changeTextSlickDots('.blog-waterpark-dining-overview li:first-of-type button', 'Freestyle Dining');
        // changeTextSlickDots('.blog-waterpark-dining-overview li:last-of-type button', 'Surf     house bar & grill');

        // setTimeout( () => {
        //     let slick_dots = document.querySelectorAll( ".slider-module__box-txt .slick-dots li" );
        //     if( slick_dots ){
        //         slick_dots.forEach( ( element, key ) => {
                    
        //             // console.log($( ".slider-module__box-txt .slick-track > div:nth-child("+(key+1)+")" ));
                    
        //             $( '.blog-waterpark-dining-overview li:nth-child('+(key+1)+') button' ).text( $( ".slider-module__box-txt .slick-track > div:nth-child("+(key+1)+")" ).data( "title" ) )

        //         } )
        //     }
        // }, 50 )

        //change content become member on waterpage section

        let urlSite = window.location.host;
        let divideUrl = urlSite.split('/');

        const goBackWaterPark = document.querySelector('#waterpark .become-member__text-member, #spa .become-member__text-member, #landing-page-month-offer .become-member__text-member, body.bourbon-steak .become-member__text-member, body.aventura-restaurants .become-member__text-member') || [];
        let goBackWaterParkBtn = goBackWaterPark.innerHTML = ('<a href="/">Back to Turnberry Isle Country Club<span class="arrow-wp"></span></a>');

        // Link to ADA map
        if(document.getElementById('map') || document.getElementById('map-category') || document.getElementById('map-category-sidebar')){ 
            document.getElementById('content').insertAdjacentHTML('beforeend', '<a class="btn ada-map-button" href="/ada-map">Accessibility Map</a>'); 
        }

        //Reload Gif on hover Water-park landing page

        function reloadOnHover(){
            let gifElements = document.querySelectorAll('.js-splash-gif');
            gifElements.forEach(gifElem => {
                let gifElem_img = gifElem.querySelector('.faqs-module__splash');
                gifElem.addEventListener('mouseenter', _=>{
                    gifElem_img.setAttribute('src', '../assets/images/waterpark-splash.gif');
                });
                gifElem.addEventListener('mouseleave', _=>{
                    gifElem_img.removeAttribute('src');
                })
            })
        }
        reloadOnHover(); 

	});

    $(window).on('load', function() {
		equalize();

	});

    $(window).scroll(function(){
        //const window_height = window.innerHeight;
        let sub_menu_w  = document.querySelector('.sub-menu__wrapper');
        if(sub_menu_w){
            let sub_menu = document.querySelector('#content .sub-menu');
            var viewportOffset = sub_menu_w.getBoundingClientRect();
            let topPos = viewportOffset.top;
            //console.log(topPos);
            if(topPos <= 80){
                sub_menu.classList.add('fixed');
            }else{
                sub_menu.classList.remove('fixed');
            }
        }
    })
    $(".learn").fancybox({
        afterShow: function() {
           $('.date').datepicker();
        }
    });
    let videoUrl;
    $('.open-video').click(function(event){
        event.preventDefault();
        videoUrl = $(this).attr('data-video');
        smallVideo =  $(this).attr('data-small');

    })
    $('.open-video').fancybox({
        afterShow   :   function() {
            $('#lightbox-video').attr('src',videoUrl);
            $('#lightbox-video')[0].play();
        },
        overlayShow : true,
        centerOnScroll : true,
        speedIn : 100,
        speedOut : 50,
        allowfullscreen:true,
        width         : '100%',
        height        : '100%',
        autosize: false
    });


    if(document.querySelector(".form-module")) {
        document.querySelector(".form-module").addEventListener("submit", function(){
            setTimeout(function(){
                document.querySelector('.fancybox-item.fancybox-close').click()
            },500)
        })
    }
    /** Functionality for .mp4 vids on youtubevideo-lightbox shortcode **/
    document.addEventListener('DOMContentLoaded', function () {
        const video = document.querySelector('#video-player');

        if (video) {
            video.pause();
            video.currentTime = 0;
        }

        document.body.addEventListener('click', function (event) {
            if (event.target.classList.contains('fancybox-close')) {
                if (video) {
                    video.pause();
                    video.currentTime = 0; 
                }
            }
            if (event.target.closest('.fancybox') && event.target.closest('.youtube-vid-img-prev a')) {
                if (video) {
                    video.play(); 
                }
            }
        });
    });
}());